const searchMatcher = (a, b)=>{
    a = a.toLowerCase();
    b = b.toLowerCase();
    let c = a.indexOf(b)
    if (c >= 0){
        return true
    }
    else{
        return false
    }
}

export {searchMatcher};